export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const SET_USER_FROM_STORAGE = 'SET_USER_FROM_STORAGE';
export const LOGOUT = 'LOGOUT';
